<template>
<div class="chapter">
<div class="inner_page">
<p class="head" id="ded"><a href="#/005_contents#rded">♦ DEDICATION ♦</a></p>
<p class="center"><em>This book is dedicated to</em></p>
<p class="centera"><em>People who have lived checkered pasts</em></p>
<p class="centera"><em>Your past is does not define, nor does it dictate your future.</em></p>
<p class="indentt"><em>“Though no one can go back and make a brand new start, anyone can start from now and make a brand new ending.”</em></p>
<p class="indent"><em>- Carl Bard</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_dedication.vue?d466dca6